import React from 'react';

import styles from './starStyles';

const Star = ({
  id,
  size = 'small',
  fillColor = '#4990E2',
  fillPercentage = '100%',
  className = ''
}) => {
  const attrs = {
    small: {
      height: '15px',
      width: '15px'
    },
    large: {
      height: '35px',
      width: '35px'
    }
  };

  // Convert integer to percent string in case it's not already
  const fillPercentageString =
    typeof fillPercentage === 'string' && /\d+%$/.test(fillPercentage)
      ? fillPercentage
      : String(fillPercentage + '%');
  const starId = id + '-star';

  const pathD =
    'm7.347 12.239l-4.408 2.317.842-4.909-3.567-3.476 4.929-.716 2.204-4.466 2.204 4.466 4.929.716-3.566 3.476.842 4.909z';

  return (
    <span className={styles.star + ` ${className}`} data-testid={id}>
      <svg
        width={attrs[size].width}
        height={attrs[size].height}
        viewBox="0 0 15 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient x1="2.32703566%" y1="50%" x2="101.914194%" y2="50%" id={starId}>
            <stop stopColor={fillColor} offset="0%" />
            <stop stopColor={fillColor} offset={fillPercentageString} />
            <stop stopColor="#AAAAAA" offset={fillPercentageString} />
            <stop stopColor="#AAAAAA" offset="100%" />
          </linearGradient>
        </defs>
        <g id="star" transform="translate(0, 0)" fill={`url(#${starId})`}>
          <path transform="translate(0-1)" d={pathD} />
        </g>
      </svg>
    </span>
  );
};

export default Star;
